import { get } from "lodash";

export const articles = (state) => get(state, "concept.articles", null);
export const selectedArticles = (state) => get(state, "concept.selectedArticles", []);
export const totalAmount = (state) => get(state, "concept.totalAmount", 0);
export const payment = (state) => get(state, "concept.payment", null);
export const captcha = (state) => get(state, "concept.captcha", null);
export const internalId = (state) => get(state, "concept.internalId", null);
